import React from 'react';
import GridTable from './GridTable';
import { isEmpty } from './format';
import styles from './styles.module.css';

/* Вкладка «Главная» (п. 4 ТЗ): шесть блоков в заданном порядке.
   Три таблицы (образование, научные мероприятия, общественная жизнь,
   спортивные и творческие мероприятия — последние три одного вида) и два
   текстовых блока. Данные приходят из родителя: в просмотре — сохранённое
   портфолио, в правке — черновик; сюда же уходят все изменения. */

export const EDU_COLUMNS = [
  { key: 'periods', label: 'Период (гг.–гг.)', className: styles.colPer },
  { key: 'instutution', label: 'Наименование образовательного учреждения, город', left: true },
  { key: 'major', label: 'Специальность', left: true },
];

export const EVENT_COLUMNS = [
  { key: 'name', label: 'Наименование мероприятия, дата', left: true },
  { key: 'participation', label: 'Форма участия', title: 'Индивидуальное выступление, участие в команде и т.п.' },
  { key: 'results', label: 'Результат' },
];

// пустая строка перечня — по ключам его колонок
export const emptyRow = (columns) => columns.reduce((row, col) => ({ ...row, [col.key]: '' }), {});

export const TABLE_BLOCKS = {
  portfolio_preveducation: { columns: EDU_COLUMNS, numbered: false },
  portfolio_scientific: { columns: EVENT_COLUMNS, numbered: true },
  portfolio_sociallife: { columns: EVENT_COLUMNS, numbered: true },
  portfolio_sport: { columns: EVENT_COLUMNS, numbered: true },
};

const TextBlock = ({ value, editing, onChange }) => {
  if (editing) {
    return (
      <textarea
        className={styles.textarea}
        value={value == null ? '' : value}
        placeholder="Не заполнено"
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
  return isEmpty(value)
    ? <div className={styles.txtNone}>не указано</div>
    : <div className={styles.txt}>{value}</div>;
};

const MainTab = ({ data, editing, onChangeText, onChangeCell, onAddRow, onDeleteRow }) => {
  const table = (field) => {
    const { columns, numbered } = TABLE_BLOCKS[field];
    return (
      <GridTable
        columns={columns}
        numbered={numbered}
        rows={Array.isArray(data[field]) ? data[field] : []}
        editing={editing}
        onChange={(row, key, value) => onChangeCell(field, row, key, value)}
        onAdd={() => onAddRow(field)}
        onDelete={(row) => onDeleteRow(field, row)}
      />
    );
  };

  return (
    <>
      <section className={styles.sec}>
        <h2>Сведения о предшествующем образовании</h2>
        {table('portfolio_preveducation')}
      </section>

      <section className={styles.sec}>
        <h2>Дополнительные сведения</h2>
        <p className={styles.hint}>Владение иностранными языками, персональным компьютером, автомобилем и тому подобное.</p>
        <TextBlock
          value={data.portfolio_description}
          editing={editing}
          onChange={(value) => onChangeText('portfolio_description', value)}
        />
      </section>

      <section className={styles.sec}>
        <h2>Интересы, предпочтения, увлечения</h2>
        <TextBlock
          value={data.portfolio_character}
          editing={editing}
          onChange={(value) => onChangeText('portfolio_character', value)}
        />
      </section>

      <section className={styles.sec}>
        <h2>Участие в научно-практических конференциях и других научных мероприятиях</h2>
        <p className={styles.hint}>Научная и научно-исследовательская деятельность, портфолио достижений.</p>
        {table('portfolio_scientific')}
      </section>

      <section className={styles.sec}>
        <h2>Участие в общественной жизни академии</h2>
        {table('portfolio_sociallife')}
      </section>

      <section className={styles.sec}>
        <h2>Участие в спортивных и творческих мероприятиях</h2>
        {table('portfolio_sport')}
      </section>
    </>
  );
};

export default MainTab;
